module.exports = __webpack_public_path__ + "img/tree-01-d-leaves.362ac594.png";